<template>
  <ErrorModal />
  <div class="rate-limit-logs-tab-content">
    <DxDataGrid
      :data-source="rateLimitingLogs"
      :remote-operations="true"
      :key-expr="'conversationId'"
      :show-borders="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      no-data-text="No results"
    >
      <DxColumn
        data-field="userId"
        data-type="string"
        caption="User ID"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="username"
        data-type="string"
        caption="Username"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="rateLimitReachedAt"
        data-type="Date"
        caption="Rate limit reached at"
        :allow-sorting="false"
        cell-template="rateLimitReachedAtCellTemplate"
      />
      <template #rateLimitReachedAtCellTemplate="rowData">
        <span>{{
          moment(rowData.data.data.rateLimitReachedAt).format(
            "MMMM Do YYYY, h:mm:ss A"
          )
        }}</span>
      </template>
      <DxColumn
        data-field="ipAddress"
        data-type="string"
        caption="IP Address"
        :allow-sorting="false"
      />
      <DxColumn
        data-field="permitLimit"
        data-type="number"
        caption="Limit"
        :allow-sorting="false"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :visible="true"
        :allowed-page-sizes="[10, 20, 50, 'all']"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
      />
      <DxLoadPanel :enabled="true" />
    </DxDataGrid>
  </div>
</template>
<script setup>
import { ref} from "vue";
import moment from "moment";
import {
  DxDataGrid,
  DxPager,
  DxPaging,
  DxColumn,
  DxLoadPanel
} from "devextreme-vue/data-grid";
import ErrorModal from "../ErrorModal.vue";
import createCustomStore from "../../../store/custom.store";

const rateLimitingLogs = ref(
  createCustomStore(
    "/api/aiAssistantLogs/getRateLimitingLogs",
    null,
    "conversationId"
  )
);
</script>
